// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iqNE","placeholdersHeader":"styles_placeholdersHeader__cYVBb","editorStyle":"styles_editorStyle__1q7Ox","placeholdersBox":"styles_placeholdersBox__1-M8f"};